import React from 'react';

interface QRCodeIconProps {
  className?: string;
}

function QRCodeIcon({ className }: QRCodeIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" className={className}>
      <mask id="a" width="25" height="25" x="0" y="0" maskUnits="userSpaceOnUse" style={{ maskType: 'alpha' }}>
        <path fill="currentColor" d="M.535.889h24v24h-24z"></path>
      </mask>
      <g mask="url(#a)">
        <path
          fill="#141412"
          fillOpacity="0.6"
          d="M13.535 21.89v-2h2v2zm-2-2v-5h2v5zm8-3v-4h2v4zm-2-4v-2h2v2zm-12 2v-2h2v2zm-2-2v-2h2v2zm9-7v-2h2v2zm-7.5 2.5h3v-3h-3zm-1.5.5v-4q0-.426.288-.713a.97.97 0 0 1 .712-.288h4q.425 0 .713.288a.97.97 0 0 1 .287.712v4a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287h-4a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713Zm1.5 11.5h3v-3h-3zm-1.5.5v-4q0-.426.288-.713a.97.97 0 0 1 .712-.288h4q.425 0 .713.288a.97.97 0 0 1 .287.712v4a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287h-4a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713Zm13.5-12.5h3v-3h-3zm-1.5.5v-4q0-.426.288-.713a.97.97 0 0 1 .712-.288h4q.425 0 .713.288a.97.97 0 0 1 .287.712v4a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287h-4a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713Zm2 13v-3h-2v-2h4v3h2v2zm-4-7v-2h4v2zm-4 0v-2h-2v-2h6v2h-2v2zm1-5v-4h2v2h2v2zm-4.75-2.25v-1.5h1.5v1.5zm0 12v-1.5h1.5v1.5zm12-12v-1.5h1.5v1.5z"
        ></path>
      </g>
    </svg>
  );
}

export default QRCodeIcon;
